export { default } from './ProductScores';
